import { phoneNumberFormatter } from '@exam-center/utils';
import { zodResolver } from '@hookform/resolvers/zod';
import type { PropsWithChildren } from '@shared/utils';
import { FormProvider, useForm } from 'react-hook-form';

import { BlockedUserSchema, type BlockedUserFormInput } from './blocked-user-form-schema';

interface BlockedUserFormProviderProps extends PropsWithChildren {
  initialValues?: BlockedUserFormInput;
}

export default function BlockedUserFormProvider(props: Readonly<BlockedUserFormProviderProps>) {
  const { children, initialValues } = props;

  const formContext = useForm<BlockedUserFormInput>({
    resolver: zodResolver(BlockedUserSchema),
    defaultValues: {
      phoneNumber: initialValues?.phoneNumber
        ? phoneNumberFormatter(initialValues.phoneNumber)
        : undefined,
    },
  });

  return <FormProvider {...formContext}>{children}</FormProvider>;
}
